module.exports = __webpack_public_path__ + "static/media/Is-four-circle_mobile.bf68cdde.png";